import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import { preloadImages, getCriticalImages, getPdfImages, getEclPdfImages } from './utils/imagePreloader';
import Header from './pages/Header';
import Hero from './pages/Hero';
import VideoSection from './components/VideoSection';
import About from './pages/About';
import Interchanges from './pages/Interchanges';
import DesignSafety from './pages/DesignSafety';
import MobilityTolling from './pages/MobilityTolling';
import ITS from './pages/ITS';
import Environment from './pages/Environment';
import DeliveryCost from './pages/DeliveryCost';
import ContactUs from './pages/ContactUs';
import PrrProject from './pages/prr-project';
import Footer from './pages/Footer';

function App() {
  const [showProjectDetail, setShowProjectDetail] = useState(false);
  const [showContactUs, setShowContactUs] = useState(false);
  const [showPrrProject, setShowPrrProject] = useState(false);
  const [language, setLanguage] = useState('kannada');

  useEffect(() => {
    document.body.classList.toggle('lang-kannada', language === 'kannada');
    document.body.classList.toggle('lang-english', language !== 'kannada');
  }, [language]);

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'contact') {
      setShowContactUs(true);
      setShowProjectDetail(false);
      setShowPrrProject(false);
    } else if (hash === 'prr-project') {
      setShowPrrProject(true);
      setShowContactUs(false);
      setShowProjectDetail(false);
    } else if (hash === 'compensation') {
      setShowProjectDetail(true);
      setShowContactUs(false);
      setShowPrrProject(false);
    } else {
      setShowProjectDetail(false);
      setShowContactUs(false);
      setShowPrrProject(false);
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash === 'contact') {
        setShowContactUs(true);
        setShowProjectDetail(false);
        setShowPrrProject(false);
      } else if (hash === 'prr-project') {
        setShowPrrProject(true);
        setShowContactUs(false);
        setShowProjectDetail(false);
      } else if (hash === 'compensation') {
        setShowProjectDetail(true);
        setShowContactUs(false);
        setShowPrrProject(false);
      } else {
        setShowProjectDetail(false);
        setShowContactUs(false);
        setShowPrrProject(false);
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const baseUrl = process.env.PUBLIC_URL || '';
    preloadImages(getCriticalImages(baseUrl));
    const deferPdfPreload = () => {
      preloadImages(getPdfImages(baseUrl)).catch(() => {});
      preloadImages(getEclPdfImages(baseUrl)).catch(() => {});
    };
    /* Start soon after first paint so blueprint/ECL pages hit cache before user opens viewer */
    const t = setTimeout(deferPdfPreload, 600);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('project-detail-active', showProjectDetail);
    return () => document.body.classList.remove('project-detail-active');
  }, [showProjectDetail]);

  const handleShowProjectDetail = useCallback(() => {
    setShowProjectDetail(true);
    setShowContactUs(false);
    setShowPrrProject(false);
    window.location.hash = 'compensation';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleBackToHome = useCallback(() => {
    setShowProjectDetail(false);
    setShowContactUs(false);
    setShowPrrProject(false);
    window.location.hash = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleShowContactUs = useCallback(() => {
    setShowContactUs(true);
    setShowProjectDetail(false);
    setShowPrrProject(false);
    window.location.hash = 'contact';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleShowPrrProject = useCallback(() => {
    setShowPrrProject(true);
    setShowContactUs(false);
    setShowProjectDetail(false);
    window.location.hash = 'prr-project';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="app">
      <Header 
        showProjectDetail={showProjectDetail}
        showContactUs={showContactUs}
        showPrrProject={showPrrProject}
        onBackToHome={handleBackToHome}
        onShowProjectDetail={handleShowProjectDetail}
        onShowContactUs={handleShowContactUs}
        onShowPrrProject={handleShowPrrProject}
        language={language}
        setLanguage={setLanguage}
      />
      {!showContactUs && !showPrrProject && (
        <>
          <Hero
            showProjectDetail={showProjectDetail}
            onExploreClick={handleShowProjectDetail}
            onBackToHome={handleBackToHome}
            language={language}
            setLanguage={setLanguage}
          />
          {!showProjectDetail && <VideoSection />}
        </>
      )}
      {showContactUs ? (
        <>
          <ContactUs language={language} />
          <Footer language={language} />
        </>
      ) : showPrrProject ? (
        <>
          <PrrProject language={language} />
          <Footer language={language} />
        </>
      ) : !showProjectDetail && (
        <>
          <About language={language} />
          <Interchanges language={language} />
          <DesignSafety language={language} />
          <MobilityTolling language={language} />
          <ITS language={language} />
          <Environment language={language} />
          <DeliveryCost language={language} />
          <Footer language={language} />
        </>
      )}
    </div>
  );
}

export default App;
